import React, { FC } from "react";
import { useTranslations } from "next-intl";

import { Checkbox, Loader } from "@/components/common";
import PaymentTableRow from "./payment-table-row";
import { IShipment } from "@/types/apiResponse.types";

type Props = {
  parcelsData: IShipment[];
  isLoading: boolean;
  selectedIds: number[];
  handleSelect: (id: number) => void;
  handleSelectAll: () => void;
};

const PaymentTable: FC<Props> = ({
  parcelsData,
  isLoading,
  selectedIds,
  handleSelect,
  handleSelectAll,
}) => {
  const t = useTranslations();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="mb-[28px] w-full px-[35px]">
      <div className="mb-[10px] flex h-[47px] items-center justify-between gap-4 text-nowrap rounded-tl-xl rounded-tr-xl bg-[#f9f9f9] text-xs font-semibold uppercase text-[#636363]">
        <div className="w-[80px] border-r pl-[20px]">
          <Checkbox
            name="selectedItem"
            onChange={handleSelectAll}
            checked={selectedIds.length === parcelsData?.length}
          />
        </div>
        <div className="w-[40px]">
          <span>{t("shop")}</span>
        </div>
        <div className="w-[300px]">
          <span>{t("tracking_number")}</span>
        </div>
        <div className="w-[70px]">
          <span>{t("category")}</span>
        </div>
        <div className="w-[150px]">
          <span>{t("transportation_price")}</span>
        </div>
      </div>
      <div>
        {parcelsData.map((item) => (
          <PaymentTableRow
            key={item.shipmentId}
            selectedIds={selectedIds}
            handleSelect={handleSelect}
            item={item}
          />
        ))}
      </div>
    </div>
  );
};

export default PaymentTable;
